import React from "react";
import ChangeLog from "../../../Common/ChangeLog/ChangeLog";
import { moduleColumn, commonColumns } from "../../../Common/Modals/ChangeLogModal/ChangeLogModal.Grid";
import getColumns from "./BusinessAnalysisChangeLogPage.Grid";

interface State {
}

class BusinessAnalysisChangeLogPage extends React.Component<any, State> {

    constructor(props: any) {
        super(props);
    }

    render(): JSX.Element {

        return (
            <>
                <h4 className="mb-3">Change Log</h4>

                <ChangeLog
                    hasWriteAccess={true}
                    getColumns={getColumns}
                    modalColumns={[moduleColumn].concat(commonColumns())}
                    backendRoute='business-analysis-version'
                    nameAndCommentRoute='name-and-comment'
                    uniqueName='business-analysis-change-log' />
            </>
        );
    }
}

export default BusinessAnalysisChangeLogPage;
